import { BuildingIcon, ShieldIcon } from "@bp/ui-components";

type OrgMarkProps = {
  org?: { system?: boolean } | null;
  size?: number;
};

export function OrgMark({ org, size = 36 }: OrgMarkProps) {
  const system = !!org?.system;
  return (
    <span
      style={{
        width: size,
        height: size,
        borderRadius: 9,
        background: system ? "var(--color-warning-lighter)" : "var(--color-primary-lighter)",
        color: system ? "var(--color-warning)" : "var(--color-primary-dark)",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      {system ? (
        <ShieldIcon style={{ fontSize: size * 0.5 }} />
      ) : (
        <BuildingIcon style={{ fontSize: size * 0.5 }} />
      )}
    </span>
  );
}
